import '@/styles/tailwind.css';
import PrimeVue from 'primevue/config';
// import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';
import Tooltip from 'primevue/tooltip';
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

// Brand theme: primary green scale derived from Xiomex brand color #75fb92
// (dark mode reads primary.400 as its base color, so 400 is the exact brand hex),
// and a dark surface scale mapped onto the brand's three near-black tones
// (#171915 base / #1a1f1c panel / #0d0f0e deep) instead of Aura's default zinc scale.
// Because nearly every dark-mode semantic token in Aura is itself defined as a
// reference to {primary.N} or {surface.N}, these two overrides alone re-skin the
// vast majority of PrimeVue components with no per-component changes needed.
const FtTheme = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#eafff0',
      100: '#d3ffe0',
      200: '#a8ffc2',
      300: '#8ffcac',
      400: '#75fb92',
      500: '#54e478',
      600: '#3fc763',
      700: '#2ea350',
      800: '#1f7d3c',
      900: '#145c2c',
      950: '#0a3818',
    },
    colorScheme: {
      dark: {
        surface: {
          0: '#ffffff',
          50: '#f9fafb',
          100: '#f3f4f6',
          200: '#e5e7eb',
          300: '#d1d5db',
          400: '#9ca3af',
          500: '#6b7280',
          600: '#4b5563',
          700: '#1f2937',
          800: '#1a1f1c',
          900: '#171915',
          950: '#0d0f0e',
        },
      },
    },
  },
});

export {
  PrimeVue,
  FtTheme,
  // ConfirmationService,
  ToastService,
  Tooltip,
};
